import {Component, OnDestroy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {map, Observable, startWith, Subject} from 'rxjs';
import {User} from '../../../model/user';

@Component({
    selector: 'app-user-form-base',
    template: '',
    standalone: false
})
export abstract class UserFormBase implements OnDestroy {
  abstract formGroup: FormGroup;
  protected destroy$ = new Subject<void>();


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  validStatus(): Observable<boolean> {
    return this.formGroup.valueChanges.pipe(
      map(() => this.formGroup.valid), startWith(false));
  }

  abstract updateUser(user: User): void;

}
